<template>
  <el-card>
    <el-row :gutter="10">
      <el-col :span="3">
        <div @click="handleChangeTabs">
          <div class="btn">
            <el-button
              :class="
                tabsName == '精品小课'
                  ? 'text-color text-color-active'
                  : 'text-color'
              "
              type="text"
              >精品小课</el-button
            >
          </div>
          <div class="btn">
            <el-button
              :class="
                tabsName == '品牌课程'
                  ? 'text-color text-color-active'
                  : 'text-color'
              "
              type="text"
              >品牌课程</el-button
            >
          </div>
          <div class="btn">
            <el-button
              :class="
                tabsName == '热门职业'
                  ? 'text-color text-color-active'
                  : 'text-color'
              "
              type="text"
              >热门职业</el-button
            >
          </div>
          <div class="btn">
            <el-button
              :class="
                tabsName == '免费试听'
                  ? 'text-color text-color-active'
                  : 'text-color'
              "
              type="text"
            >免费试听</el-button
            >
          </div>
          <!-- <div class="btn">
            <el-button
              :class="
                tabsName == '热门证书'
                  ? 'text-color text-color-active'
                  : 'text-color'
              "
              type="text"
              >热门证书</el-button
            >
          </div> -->
        </div>
      </el-col>
      <el-col :span="1" style="text-align: center">
        <div class="vertical-line"></div>
      </el-col>
      <el-col :span="20" class="top20" v-loading="loading">
        <el-col :span="24">
          <span class="tabsName">{{ tabsName }}({{ goodsNum || 0 }})</span>
          <el-input
            size="small"
            style="width: 20%"
            v-model="goodsName"
            placeholder="商品名/商品编号"
            clearable
          ></el-input>
          <el-button size="small" @click="getBindingGoodsList" type="primary"
            >查询</el-button
          >
          <el-button @click="toClassifyManage" size="small" type="primary"
            >分类管理</el-button
          >
        </el-col>
        <el-col :span="24">
          <classification
          @saveIndex="saveSelectClassifyIndex"
            @changeIds="(ids) => getBindingGoodsList(ids)"
            :data="classifyData"
          ></classification>
        </el-col>
        <el-col :span="24">
          <div v-if="tabsName != '热门证书'" class="course-body">
            <div class="default-add-btn" @click="openAddCourseDialog" v-if="tabsName != '免费试听'">
              +绑定商品
            </div>
            <div v-if="tabsName != '免费试听'"
              class="course-item"
              v-for="(item, index) in courseList"
              :key="index"
            >
              <div class="del-btn" @click="delCourseItem(item.classificationId,0)"><el-button type="text">删除</el-button></div>
              <img class="course-poster" :src="item.logo" alt="" />
              <div class="course-info">
                <h5 class="course-name">
                  {{ item.name }}
                </h5>
                <div class="course-detail">
                  <span class="course-price">
                    <b>￥{{ item.price }}</b>
                    <i>原价{{ item.originalPrice }}</i>
                  </span>
                  <span class="course-number">{{ item.sellCount }}人报名</span>
                </div>
              </div>
            </div>
              <div v-if="tabsName == '免费试听'">
                <el-button type="primary" @click="openAddCourseDialog">绑定视频</el-button>
                <el-table
                          ref="multipleTables"
                          :data="courseList"
                          tooltip-effect="dark"
                          style="width: 100%"
                          border
                >
                  <el-table-column
                    label="封面"
                    :show-overflow-tooltip="true"
                    align="center"
                  >
                    <template slot-scope="scope">
                        <img
                          style="width: 80px; height: 60px"
                          :src="
                            scope.row.attachment.img
                              ? scope.row.attachment.img
                              : 'https://n.sinaimg.cn/tech/transform/547/w350h197/20190902/2e6d-ieaiqii0404478.gif'"/>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="视频名称"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      {{scope.row.attachment.name}}
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="大小"
                    :show-overflow-tooltip="true"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope" v-if="scope.row.attachment.size != null"
                    >{{ (scope.row.attachment.size / 1024 / 1024).toFixed(4) }}MB</template
                    >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="videoInfo.url"
                    label="播放"
                    width="100"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <i
                        class="el-icon-caret-right"
                        style="font-size: 20px; color: #409eff"
                        @click="inintVideo(scope.row)"
                      ></i>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="duration" align="center" width="100" label="时长"></el-table-column> -->
                  <el-table-column prop label="操作" width="160" align="center">
                    <template slot-scope="scope">
                      <div class="operationGroup">
                        <el-button type="text" size="small" @click="delCourseItem(scope.row.id,0)"
                        >解绑</el-button>
                        <el-button type="text" size="small" @click="getGoodsListByVideoRelation(scope.row.id)"
                        >商品管理</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>



            </div>
             <div v-else class="course-body">
            <div class="default-add-btn" @click="openAddCourseDialog">
              +绑定报考指南
            </div>
               <div
              class="course-item"
              v-for="(item, index) in courseList"
              :key="index"
            >
              <div class="del-btn" @click="delCourseItem(item.classificationId,0)"><el-button type="text">删除</el-button></div>
              <img class="course-poster" :src="item.logo" alt="" />
              <div class="guide-info">
                <h5 class="guide-name">
                  {{ item.guideName }}
                </h5>
                <div class="guide-detail">
                  报考指南
                </div>
              </div>
            </div>
            </div>
        </el-col>
      </el-col>
    </el-row>

    <el-dialog
      title="添加商品"
      :visible.sync="addCourseVisible"
      width="80%"
      :before-close="handleClose"
    >
      <el-row>
        <el-col :span="24">
          <el-form
            ref="form"
            :rules="rules"
            :model="bindingParams"
            label-width="80px"
          >
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item prop="classifyId" label="所属分类">
                <el-select
                  @change="handleChangeChildrenData"
                  v-model="bindingParams.classifyId"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in bindingFirstClassify.children"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item prop="classificationId" label="所属科目">
                <el-select
                  v-model="bindingParams.classificationId"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in bindingSecondClassify"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
        <el-col :span="24">
          <p class="desc">请先选择要绑定的分类和科目⬆⬆⬆</p>
        </el-col>
      </el-row>

      <el-row class="mt20" type="flex" align="middle">
        <el-col :span="2">已选{{ selectNum }}</el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-cascader
            style="width: 100%"
            clearable
            collapse-tags
            v-model="courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属科目"
            :options="subjectTreeList"
            @change="subjectSearchChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-input
            v-model="searchForm.name"
            placeholder="商品名/商品编号"
          ></el-input>
        </el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-button type="primary" @click="search">查询</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="24">
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            height="500"
            highlight-current-row
            @selection-change="handleSelectionChange"
            border
            v-loading="loading1"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" show-overflow-tooltip label="商品">
              <template slot-scope="row">
                <el-row>
                  <el-col :span="8">
                    <span>
                      <img
                        style="margin-right: 10px"
                        width="100%"
                        height="auto"
                        :src="
                          row.row.logo
                            ? row.row.logo
                            : '../../../static/image/noImg.png'
                        "
                      />
                    </span>
                  </el-col>
                  <el-col :span="16">
                    <span style="color: rgb(77, 148, 255); margin-left: 10px">{{
                      row.row.name
                    }}</span>
                    <span style="display: block; margin-left: 10px">
                      <span style="color: red">￥{{ row.row.price }}</span>
                      <span
                        style="
                          text-decoration: line-through;
                          color: rgb(162, 170, 188);
                        "
                        >￥{{ row.row.originalPrice }}</span
                      >
                    </span>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              width="200"
              prop="agentPrice"
              label="售价"
            >
              <template slot-scope="row">
                <span style="display: block">
                  <span style="color: red">￥{{ row.row.price }}</span>
                  <span
                    style="
                      text-decoration: line-through;
                      color: rgb(162, 170, 188);
                    "
                    >￥{{ row.row.originalPrice }}</span
                  >
                </span>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="validDay"
              width="100"
              label="有效期"
            >
              <template slot-scope="row">{{
                row.row.validDay ? row.row.validDay + "天" : "不限"
              }}</template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              width="200"
              prop="subjectCourseName"
              label="所属科目"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              width="120"
              prop="type"
              label="类型"
            ></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="添加视频"
      :visible.sync="addVideoVisible"
      width="80%"
      :before-close="handleClose"
    >
      <el-row>
        <el-col :span="24">
          <el-form
            ref="form"
            :rules="rules"
            :model="bindingParams"
            label-width="80px"
          >
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item prop="classifyId" label="所属分类">
                <el-select
                  @change="handleChangeChildrenData"
                  v-model="bindingParams.classifyId"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in bindingFirstClassify.children"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item prop="classificationId" label="所属科目">
                <el-select
                  v-model="bindingParams.classificationId"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in bindingSecondClassify"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="24" :md="16" :lg="16">
          <span>选择视频</span>
          <el-button style="margin-left:20px;" type="primary" plain @click="selectVideoVisibleBlock = true,selectVideoVisible = true">选择视频</el-button>
        </el-col>
      </el-row>

      <div>
        <el-row :gutter="20">
          <el-col :sm="24" :md="16" :lg="16">
            <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="videoList" tooltip-effect="dark" style="margin-top: 20px;margin-left:70px;" border @selection-change="selectionVideoChange">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="name" label="视频" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div style="display:flex;justify-content:space-between">
                    <el-input v-if="scope.row.editBlock" size="small" v-model="scope.row.name" style="width:200px">
                      <span class="operation-style" style="line-height:35px" slot="suffix" @click="updateVideoInfoByAttachmentList(scope.row)">保存</span>
                      <span style="line-height:35px;margin-left:10px" slot="suffix" @click="editBlockCancel(scope.row)">取消</span>
                    </el-input>
                    <div v-else>{{scope.row.name}}</div>
                    <i style="line-height:22.4px" class="operation-style el-icon-edit" @click="editBlockClick(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="size" label="大小" width="120">
                <template slot-scope="scope">{{(scope.row.size/1024/1024).toFixed(4)}}MB</template>
              </el-table-column>
              <el-table-column prop label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <div class="operationGroup">
                    <span class="operation-style" @click="deleteVideo(scope.row)">移除</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="16" :lg="16">
            <div style="margin-top: 20px;margin-left:70px;">
              <el-button @click="videoList = []">重 置</el-button>
              <el-button type="primary" @click="bindTencent">提 交</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog title="选择视频" :visible.sync="selectVideoVisible" width="800px" left>
      <videoMaterial @videoListChange="changeVideoList" v-if="selectVideoVisibleBlock"></videoMaterial>
    </el-dialog>

       <el-dialog
      title="添加报考指南"
      :visible.sync="addGuideVisible"
      width="80%"
      :before-close="handleClose"
    >
      <el-row>
        <el-col :span="24">
          <el-form
            ref="form"
            :rules="rules"
            :model="bindingParams"
            label-width="80px"
          >
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item prop="classifyId" label="所属分类">
                <el-select
                  @change="handleChangeChildrenData"
                  v-model="bindingParams.classifyId"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in bindingFirstClassify.children"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item prop="classificationId" label="所属科目">
                <el-select
                  v-model="bindingParams.classificationId"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in bindingSecondClassify"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
        <el-col :span="24">
          <p class="desc">请先选择要绑定的分类和科目⬆⬆⬆</p>
        </el-col>
      </el-row>

      <el-row class="mt20" type="flex" align="middle">
        <el-col :span="2">已选{{ selectNum }}</el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-cascader
            style="width: 100%"
            clearable
            collapse-tags
            v-model="courseIds"
            :show-all-levels="false"
            :props="guideTreeProps"
            placeholder="请选择所属科目"
            :options="guideTreeList"
            @change="guideSearchChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-input
            v-model="guideSearchForm.guideName"
            placeholder="报考指南名称"
          ></el-input>
        </el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-button type="primary" @click="search">查询</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="24">
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            highlight-current-row
            @selection-change="handleSelectionChange"
            border
            v-loading="loading1"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
          >
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column
              show-overflow-tooltip
              prop="guideName"
              label="报考指南名称"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="dictionaryName"
              label="所属类型"
            ></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="预览视频"
      :visible.sync="videoDialog"
      @close="closeDialog"
      width="900px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <video
        v-if="videoShow"
        id="player-container-id"
        width="860"
        height="450"
        preload="auto"
        playsinline
        webkit-playsinline
      ></video>
    </el-dialog>

    <el-dialog
      title="视频绑定商品"
      :visible.sync="addVideoGoodsRelationVisible"
      width="80%"
      :before-close="handleCloseVideo"
    >
      <el-row class="mt20" type="flex" align="middle">
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-cascader
            style="width: 100%"
            clearable
            collapse-tags
            v-model="courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属科目"
            :options="subjectTreeList"
            @change="subjectSearchChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-input
            v-model="searchForm.name"
            placeholder="商品名/商品编号"
          ></el-input>
        </el-col>
        <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
          <el-button type="primary" @click="search">查询</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="24">
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            height="500"
            highlight-current-row
            @selection-change="handleSelectionChange"
            border
            v-loading="loading1"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" show-overflow-tooltip label="商品">
              <template slot-scope="row">
                <el-row>
                  <el-col :span="8">
                    <span>
                      <img
                        style="margin-right: 10px"
                        width="100%"
                        height="auto"
                        :src="
                          row.row.logo
                            ? row.row.logo
                            : '../../../static/image/noImg.png'
                        "
                      />
                    </span>
                  </el-col>
                  <el-col :span="16">
                    <span style="color: rgb(77, 148, 255); margin-left: 10px">{{
                        row.row.name
                      }}</span>
                    <span style="display: block; margin-left: 10px">
                      <span style="color: red">￥{{ row.row.price }}</span>
                      <span
                        style="
                          text-decoration: line-through;
                          color: rgb(162, 170, 188);
                        "
                      >￥{{ row.row.originalPrice }}</span
                      >
                    </span>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              width="200"
              prop="agentPrice"
              label="售价"
            >
              <template slot-scope="row">
                <span style="display: block">
                  <span style="color: red">￥{{ row.row.price }}</span>
                  <span
                    style="
                      text-decoration: line-through;
                      color: rgb(162, 170, 188);
                    "
                  >￥{{ row.row.originalPrice }}</span
                  >
                </span>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="validDay"
              width="100"
              label="有效期"
            >
              <template slot-scope="row">{{
                  row.row.validDay ? row.row.validDay + "天" : "不限"
                }}
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              width="200"
              prop="subjectCourseName"
              label="所属科目"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              width="120"
              prop="type"
              label="类型"
            ></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitByVideo()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="视频绑定商品列表"
      :visible.sync="goodsListByVideoRelationVisible"
      width="80%"
      :before-close="handleClose">
      <el-button type="primary" size="small" @click="addVideoGoodsRelation()"
      >绑定商品</el-button>
      <el-table
        ref="multipleTables"
        :data="videoGoodsList"
        tooltip-effect="dark"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="name"
          label="商品"
          show-overflow-tooltip
          width="260px"
        >
          <template slot-scope="row">
            <div style="display: flex">
              <img
                style="width: 120px; height: 60px"
                :src="
                  row.row.logo
                    ? row.row.logo
                    : 'http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15743276279534477403800.png'
                "
              />
              <div style="margin-left: 10px; width: 130px">
                <!-- <span style="color:rgb(106,224,105)" v-if="row.row.recommend=='1'">{{"[推荐]"}}</span>
                <span style="color:rgb(106,224,105)" v-if="row.row.hot=='1'">{{"[热门]"}}</span>-->
                <!-- <span style="color:rgb(77,145,225)">{{row.row.name}}</span> -->
                <span>{{ row.row.name }}</span>
                <span style="display: block">
                  <span style="color: red">￥{{ row.row.price }}</span>
                  <span
                    style="
                      text-decoration: line-through;
                      color: rgb(162, 170, 188);
                    "
                  >￥{{ row.row.originalPrice }}</span
                  >
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="validDay"
          align="center"
          show-overflow-tooltip
          label="有效期"
          width="130px"
        >
          <template slot-scope="row">{{
              row.row.validDay ? row.row.validDay + "天" : "不限"
            }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="postponeDay" label="延期天数" min-width="8%">
          <template slot-scope="row">{{row.row.postponeDay==""?"-":row.row.postponeDay}}天</template>
        </el-table-column>-->

        <el-table-column
          prop="type"
          label="类型"
          show-overflow-tooltip
          :render-header="renderSpecNameHeader"
          width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.type"
              placement="top"
              effect="light"
            >
              <div
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ scope.row.type }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="sellCount"
          label="真实销量"
          align="center"
          width="80px"
        >
          <template slot-scope="row">
            <!-- <span>{{row.row.actualSellCount}}</span> -->
            <el-button @click="goodsNumber(row.row.id)" type="text"
            >{{
                row.row.actualSellCount == null ? 0 : row.row.actualSellCount
              }}
            </el-button>
            <!-- <el-button
              @click="goodsNumber(row.row.id)"
              type="text"
            >{{row.row.stock==null?0:row.row.stock}}</el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="validDay"
          label="上架时间"
          width="200px"
          align="center"
        >
          <template slot-scope="row">{{ row.row.onTime }}</template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="addWay"
          label="添加路径"
          width="200px"
          align="center"
        >
          <template slot-scope="row">
            <span v-if="row.row.addWay == 1">商品库</span>
            <span v-if="row.row.addWay == 2">自建</span>
          </template>
        </el-table-column>

        <el-table-column prop label="操作" width="160" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <el-button type="text" size="small" @click="delCourseItem(scope.row.classificationGoodsRelationId,1)"
              >解绑
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>
    <el-dialog
      title="上传封面"
      :visible.sync="uploadImgVisible"
      width="80%"
      :before-close="handleClose">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="封面" prop="cover">
            <el-upload
              class="avatar-uploader"
              :action="fileObj.url"
              :headers="reqData"
              list-type="picture"
              :show-file-list="false"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :before-upload="beforeUpload"
              :on-success="UploadSuccess">
              <img v-if="formImgUrl" :src="formImgUrl" class="avatar"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>

      </el-row>
      <el-button type="primary" @click="updateImgToClassificationRelation()">确定</el-button>

    </el-dialog>

  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import classification from "@/components/CommodityClassificationManagement/components/classification";
import videoMaterial from "@/components/common/videoMaterial";

export default {
  components: {
    classification,
    videoMaterial,
  },
  data() {
    return {
      tabsName: "精品小课",
      goodsName: "",
      goodsNum: 0,
      courseList:[],
      addCourseVisible: false,
      tableData: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 20,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      selectVideoVisible: false,
      selectVideoVisibleBlock: false,
      videoDialog: false,
      videoList: [],
      ids: [],
      classifyList: [],
      classifyData: {},
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      formImgUrl:'',
      forImgByClassificationRelationId:'',
      searchForm: {
        subjectIds: [],
        name: "",
      },
      bindingParams: {
        classifyId: "",
        classificationId: "",
      },
      rules: {
        classifyId: [
          { required: true, message: "请选择所属分类", trigger: "change" },
        ],
        classificationId: [
          { required: true, message: "请选择所属科目", trigger: "change" },
        ],
      },
      selectRecords: [],
      bindingFirstClassify: [],
      bindingSecondClassify: [],

      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },

      subjectTreeList: [],
      courseIds: [],
      loading1: false,

      loading: false,

      selectNum: 0,

      bindGoodsParams: [],

      addGuideVisible:false,
      addVideoVisible:false,
      addVideoGoodsRelationVisible: false,
      goodsListByVideoRelationVisible: false,
      uploadImgVisible: false,
      videoGoodsList: [],
      guideTreeList:[],
      guideTreeProps: {
        value: "id",
        label: "name",
      },
      guideSearchForm: {
        dictionaryId: '',
        guideName: "",
      },

      firstFloorIndex:0,
      secondFloorIndex:0,
      videoShow: false,
      loadVideoShow: false,
      pidByVideoRelationId: null,
    };
  },
  mounted() {
    this.getClassifyList();
  },
  methods: {
    reqData() {
      return this.$store.state.user;
    },
    handleRemove(file, fileList) {
    },
    handleChange(file, fileList) {
    },
    beforeUpload(file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    UploadSuccess(res, file, fileList, val) {
      this.form.cover = res.data;
    },
    closeDialog() {
      this.player.dispose();
      this.videoShow = false;
    },
    inintVideo(item) {
      this.videoDialog = true;
      this.videoShow = true;
      this.loadVideoShow = true;
      this.$nextTick(function () {
        this.player = TCPlayer("player-container-id", {
          fileID: item.attachment.objectId, // 请传入需要播放的视频 filID（必须）
          appID: 1251150518, // 请传入点播账号的 appID（必须）
          autoplay: true,
        });
      });
    },
    bindTencent () {
      console.log(this.bindTencentBlock)
      // debugger
      if (this.bindTencentBlock) {
        return;
      }
      if (this.ids.length == 0) {
        this.$message.error("请选择需要绑定的视频！");
        return;
      }
      this.bindTencentBlock = true;

      let params = [];
      this.ids.forEach((el) => {
        params.push({
          classificationId: this.bindingParams.classificationId,
          objectId: el.id,
          type: 3,
        });
      });
      this.$refs.form.validate((valid) => {
        this.bindTencentBlock = false;
        if (valid) {
          this.api.classifyManage
            .addClassificationGoodsRelationList(params)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.getBindingGoodsList();
              } else {
                this.$message.error(res.message || '系统异常')
              }
            });
          this.handleClose();
        }
      });

    },
    updateVideoInfoByAttachmentList (row) {
      this.api.videoInfo.updateVideoInfoByAttachmentList(row).then(result => {
        if (result.success) {
          this.$set(row, 'editBlock', false)
        }
      })
    },
    editBlockClick (row) {
      console.log("row", row)
      this.$set(row, 'editBlock', true)
    },
    editBlockCancel (row) {
      this.$set(row, 'editBlock', false)
    },
    deleteVideo (row) {
      this.$confirm("将会删除该视频，是否确认删除？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.videoList.forEach((e, index) => {
          if (e.id == row.id) {
            this.videoList.splice(index, 1);
          }
        });
      });
    },
    changeVideoList (ids) {
      this.videoList = ids;
      this.videoList.forEach(e => {
        this.$set(e, 'editBlock', false)
      })
      this.selectVideoVisible = false;
      this.selectVideoVisibleBlock = false;
    },
    selectionVideoChange (val) {
      this.ids = val;
    },
    saveSelectClassifyIndex(key,index){
      if(key == 'firstClassifyList') this.firstFloorIndex = index
      else this.secondFloorIndex = index
    },
    addVideoGoodsRelation() {
      this.selectNum = 0;
      this.selectRecords = [];
      this.addVideoGoodsRelationVisible = true;
      this.getSubjectTreeList();
      this.getCourseList();
    },
    getGoodsListByVideoRelation(id) {
      this.goodsListByVideoRelationVisible = true;
      if (id != null) {
        this.pidByVideoRelationId = id;
      }
      let param = {pid: this.pidByVideoRelationId};
      this.api.classifyManage
        .getClassificationGoodsInfoListByVideo(param)
        .then((res) => {
          if (res.code == 200) {
            this.videoGoodsList = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    delCourseItem(id,type){
      this.$confirm('此操作将解除商品/报考指南/视频的绑定, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.api.classifyManage.deleteClassificationGoodsRelation(id).then(res=>{
            this.getBindingGoodsList()
            if(type == 1){
              this.getGoodsListByVideoRelation()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    uploadImg(id){
      this.forImgByClassificationRelationId = id;
      this.formImgUrl = '';
      this.uploadImgVisible = true;
    },
    updateImgToClassificationRelation(){
      let param = {
        id: this.forImgByClassificationRelationId,
        img: this.formImgUrl,
      };
      this.api.classifyManage
        .updateClassificationGoodsRelation(param)
        .then((res) => {
          if (res.code == 200) {
            this.videoGoodsList = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    guideSearchChange(e){
      this.guideSearchForm.dictionaryId = e[0] || '';
    },
    getGuideTreeList(){
      this.api.guideEx
        .getDictionaryGuide().then(res=>{
          console.log(res);
          this.guideTreeList = res.data
        })

    },
    openAddCourseDialog() {
      this.page.pageNumber = 1
      console.log(this.bindingFirstClassify.children[this.firstFloorIndex],this.bindingSecondClassify[this.secondFloorIndex - 1],333333332);
      console.log(this.firstFloorIndex,this.bindingFirstClassify.children,this.secondFloorIndex,this.bindingSecondClassify,22223);
      this.courseIds = [];
      let classifyId = undefined
      if(this.firstFloorIndex > 0){
        classifyId = this.bindingFirstClassify.children[this.firstFloorIndex - 1].id
        console.log(classifyId);
        this.handleChangeChildrenData(classifyId)
        this.bindingParams.classifyId = classifyId
      }else{
  this.bindingParams = {
        classifyId: undefined,
        classificationId:  undefined,
      };
      }

      console.log(this.bindingParams);
      this.searchForm = {
        subjectIds: [],
        name: "",
      }
      if(this.tabsName == '免费试听') {
        this.addVideoVisible = true
        this.videoList = [];
      }else {
        if(this.tabsName == '热门证书') {
          this.addGuideVisible = true
          this.getGuideTreeList()
        }else {
        this.addCourseVisible = true
        this.getSubjectTreeList();
        }
        this.getCourseList();
      }
    },
    handleClose() {
      this.addCourseVisible = false;
      this.addGuideVisible = false;
      this.addVideoVisible = false;
      this.addVideoGoodsRelationVisible = false;
      this.goodsListByVideoRelationVisible = false;
      this.uploadImgVisible = false;
      this.formImgUrl = '';
    },
    handleCloseVideo() {
      this.addVideoGoodsRelationVisible = false;
      this.formImgUrl = '';
    },
    submit() {
      let params = [];
      this.selectRecords.forEach((el) => {
        params.push({
          classificationId: this.bindingParams.classificationId,
          objectId: el.id,
        });
      });
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.api.classifyManage
            .addClassificationGoodsRelationList(params)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.getBindingGoodsList();
              }
            });
          this.handleClose();
        }
      });
    },
    submitByVideo() {
      let params = [];
      this.selectRecords.forEach((el) => {
        params.push({
          classificationId: this.bindingParams.classificationId,
          objectId: el.id,
          type: 4,
          pid: this.pidByVideoRelationId,
        });
      });
      this.api.classifyManage
        .addClassificationGoodsRelationList(params)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.getGoodsListByVideoRelation();
          }
        });
      this.handleCloseVideo();
    },

    getBindingGoodsList(arr = []) {
      this.loading = true;
      if (arr.length > 0) {
        this.bindGoodsParams = arr;
      }
// name: this.goodsName,
      let params = {

        classificationIds: [...this.bindGoodsParams],
      };
      let apiName = ''
      if(this.tabsName == '热门证书'){
        apiName = 'getClassificationSubjectGuideList'
        params.guideName = this.goodsName
      }else{
         apiName = 'getClassificationGoodsInfoList'
         params.name = this.goodsName
      }
      if(this.tabsName == '免费试听' ){
        params.classificationRelationType = 1;
      }
      this.api.classifyManage[apiName](params)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.courseList = res.data;
            console.log(this.courseList, 3232);
            this.getCount();
          }
        })
        .finally(() => (this.loading = false));
    },
    handleSelectionChange(row) {
      this.selectNum = row.length;
      this.selectRecords = row;
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getCourseList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getCourseList();
    },
    search() {
      this.getCourseList();
    },
    getCourseList() {
      this.tableData = [];
      this.loading1 = true;
      let params = {};
      let apiName = ''
      if(this.tabsName == '热门证书'){
        apiName = 'getGuideList'
        params = Object.assign({},{pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,},this.guideSearchForm)
      }
      else {
        apiName = 'getGoodsList'
        params = Object.assign({},{pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,},this.searchForm)
      }
      console.log(params,34334);
      this.api.classifyManage[apiName](params)
        .then((res) => {
          if (res.code == 200) {
            const { data } = res;
            this.tableData = data.records;
            this.page.total = data.total;
          }
        })
        .finally(() => (this.loading1 = false));
    },
    getClassifyList() {
      this.api.classifyManage.getClassificationManagementList().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.classifyList = res.data;
          this.classifyData = this.classifyList.filter(
            (el) => el.name == this.tabsName
          )[0];
          this.bindingFirstClassify = JSON.parse(
            JSON.stringify(this.classifyData)
          );
          console.log(this.classifyData, 44);
          this.bindGoodsParams = [];
          this.classifyData.children.forEach((el) => {
            if (el.children.length > 0) {
              el.children.forEach((item) => {
                this.bindGoodsParams.push(item.id);
              });
            }
          });
          console.log(this.bindGoodsParams, 2323);
          this.getBindingGoodsList();
        }
      });
    },

    handleChangeChildrenData(e) {
      this.bindingSecondClassify = [];
      if (e) {
        this.bindingSecondClassify = this.bindingFirstClassify.children.filter(
          (el) => el.id == e
        )[0].children;
        if(this.secondFloorIndex > 0){
          let classificationId = this.bindingSecondClassify[this.secondFloorIndex - 1].id
          this.bindingParams.classificationId = classificationId
          console.log(this.bindingParams);
        }

      } else {
        this.bindingParams.classificationId = "";
      }
    },
    handleChangeTabs(e) {
      console.log(e.target.textContent);
      this.tabsName = e.target.textContent;
      this.classifyData = this.classifyList.filter(
        (el) => el.name == this.tabsName
      )[0];

      this.bindingFirstClassify = JSON.parse(JSON.stringify(this.classifyData));

      this.bindGoodsParams = [];
          this.classifyData.children.forEach((el) => {
            if (el.children.length > 0) {
              el.children.forEach((item) => {
                this.bindGoodsParams.push(item.id);
              });
            }
          });
          console.log(this.bindGoodsParams, 44223);
      this.getBindingGoodsList()
      console.info(this.tabsName,"tabsName = ")
    },

    subjectSearchChange(e) {
      console.log(e);
      this.searchForm.subjectIds = [];
      e.forEach((el) => {
        this.searchForm.subjectIds.push(el[1]);
      });
      // this.searchForm.subjectIds = [];
      // this.courseIds.forEach((item) => {
      //   this.searchForm.subjectIds.push(item[1]);
      // });
      // console.log(this.searchForm.subjectIds);
    },
    getSubjectTreeList() {
      // 获取课程
      this.api.campus
        .getPermissionSubjectTree()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;

                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }

          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCount() {
      this.api.classifyManage.getClassificationCount({
          classificationId: this.classifyData.id,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.goodsNum = res.data;
          }
        });
    },
    toClassifyManage() {
      this.$router.push({
        path: "/goodsClassifyManage",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top20 {
  margin-top: 10px;
}
.btn {
  margin: 20px 0;
  text-align: center;
  background-color: #eeecec;
  .text-color {
    color: #000;
    &.text-color-active {
      color: #409eff;
    }
  }
}
.vertical-line {
  margin-top: 20px;
  height: calc(100vh);
  width: 2px;
  text-align: center;
  background-color: #c5c5c5;
}
.tabsName {
  margin-right: 10px;
  font-size: 16px;
  font-weight: bold;
}

.default-add-btn {
  margin-right: 20px;
  margin-bottom: 20px;
  width: 200px;
  height: 200px;
  text-align: center;
  line-height: 200px;
  color: #409eff;
  font-size: 16px;
  border: 1px solid #cce6ff;
  background-color: #e6f1fc;
  cursor: pointer;
}
.course-body {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  .course-item {
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    height: 200px;
    background-color: #fff;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    &:hover {
      .del-btn {
        display: block;
      }
    }
    .del-btn {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 200px;
      transform: translate(-50%, -50%);
      background-color: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      .el-button {
        font-size: 14px;
        color: #fc5e5e;
      }
    }
    .course-poster {
      width: 200px;
      height: 150px;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
    }
    .course-info {
      .course-name {
        margin: 5px 0;
        width: 200px;
        font-size: 14px;
        font-weight: normal;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .course-detail {
        display: flex;
        justify-content: space-between;
        .course-price {
          & b {
            font-style: normal;
            font-size: 13px;
            color: #fc5e5e;
          }
          & i {
            font-style: normal;
            font-size: 12px;
            text-decoration: line-through;
            color: #c5c5c5;
          }
        }
        .course-number {
          font-size: 12px;
          color: #333;
        }
      }
    }
    .guide-info{
      padding: 0 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .guide-name{}
      .guide-detail{
        padding: 5px 10px;
        background-color: #cfd4d9;
        border-radius: 8px;
      }
    }
  }
}

.el-form-item {
  margin-bottom: 0;
}
.desc {
  color: #c5c5c5;
  font-size: 13px;
}
.mt20 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.del-btn {
}
</style>



// WEBPACK FOOTER //
// src/components/CommodityClassificationManagement/index.vue